import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ManageInvoicesComponent } from './manage-invoices.component';
import { NonMovementModule } from '../non-movement-transactions/non-movement.module';

const routes: Routes = [
  { path: '', component: ManageInvoicesComponent, data: { title: 'Manage Invoices' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageInvoicesRoutingModule {}

@NgModule({
  imports: [
    ManageInvoicesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    NonMovementModule,
  ],
  declarations: [ManageInvoicesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageInvoicesModule {}
